import React from 'react';

export interface ContentProps {}

export const Content = (props: React.PropsWithChildren<ContentProps>) => {
  return <>{props.children}</>;
};
